// A recurring policy permits February 29; in non-leap years it expires on
// February's final day. Other impossible month/day combinations are rejected.
export function expiryDaysInMonth(month: number, year = 2000): number {
  return new Date(Date.UTC(year, month, 0)).getUTCDate();
}

export function validRecurringExpiry(month: unknown, day: unknown): boolean {
  if (month == null && day == null) return true;
  if (month == null || day == null) return false;
  const m = Number(month), d = Number(day);
  return Number.isInteger(m) && m >= 1 && m <= 12 && Number.isInteger(d)
    && d >= 1 && d <= expiryDaysInMonth(m);
}

export function policyExpiryDate(year: number, month: unknown, day: unknown): string | null {
  if (month == null || day == null || !validRecurringExpiry(month, day)) return null;
  const m = Number(month), d = Math.min(Number(day), expiryDaysInMonth(m, year));
  return `${year}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
}
